export default __webpack_public_path__ + "static/media/Savant's Armbands of the Celestial Hilt.508e374a.jpg";